import React, { useEffect, useState } from 'react';
import api from '../../services/api';
import alertService from '../../utils/alert';

const DAYS = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
const DEFAULT = { enabled: false, text: '', timezone: 'Asia/Kolkata', hours: Object.fromEntries(DAYS.map((d) => [d, { enabled: !['saturday', 'sunday'].includes(d), open: '09:00', close: '18:00' }])) };
const input = 'border border-[#D8DDE6] rounded-[4px] px-2 py-1 text-[12px]';

// "We're closed" note sent when a customer writes outside business hours (once per customer per 12 hours).
export default function WhatsAppAwayPanel() {
  const [cfg, setCfg] = useState(DEFAULT);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get('/meta/away-message').then((r) => { if (r.data.data) setCfg({ ...DEFAULT, ...r.data.data, hours: { ...DEFAULT.hours, ...r.data.data.hours } }); }).catch(() => {});
  }, []);

  const setDay = (d, patch) => setCfg((c) => ({ ...c, hours: { ...c.hours, [d]: { ...c.hours[d], ...patch } } }));
  const save = async () => {
    setSaving(true);
    try { await api.put('/meta/away-message', cfg); alertService.success?.('Saved', 'Away message saved'); } catch (e) { alertService.error('Error', e.response?.data?.error || 'Could not save'); } finally { setSaving(false); }
  };

  return (
    <div className="sf-card">
      <div className="sf-card-header"><h3 className="sf-card-title">Away message</h3></div>
      <div className="sf-card-body space-y-3">
        <label className="flex items-center gap-2 text-[13px]"><input type="checkbox" checked={cfg.enabled} onChange={(e) => setCfg({ ...cfg, enabled: e.target.checked })} /> Reply automatically when customers write outside business hours</label>
        <textarea rows={3} className={`${input} w-full resize-none`} placeholder="We're closed right now and will reply when we're back." value={cfg.text} onChange={(e) => setCfg({ ...cfg, text: e.target.value })} />
        <label className="block text-[12px] text-[#706E6B]">Timezone (e.g. Asia/Kolkata)<input className={`${input} w-full mt-1`} value={cfg.timezone} onChange={(e) => setCfg({ ...cfg, timezone: e.target.value })} /></label>
        <div className="space-y-1">
          {DAYS.map((d) => (
            <div key={d} className="flex items-center gap-2 text-[12px]">
              <label className="w-24 capitalize flex items-center gap-1"><input type="checkbox" checked={cfg.hours[d].enabled} onChange={(e) => setDay(d, { enabled: e.target.checked })} />{d.slice(0, 3)}</label>
              <input type="time" className={input} disabled={!cfg.hours[d].enabled} value={cfg.hours[d].open} onChange={(e) => setDay(d, { open: e.target.value })} />
              <span>to</span>
              <input type="time" className={input} disabled={!cfg.hours[d].enabled} value={cfg.hours[d].close} onChange={(e) => setDay(d, { close: e.target.value })} />
            </div>
          ))}
        </div>
        <button onClick={save} disabled={saving} className="h-8 bg-[#0176D3] hover:bg-[#014486] disabled:opacity-60 text-white text-[13px] font-semibold px-3 rounded">{saving ? 'Saving…' : 'Save'}</button>
      </div>
    </div>
  );
}
